import { createFileRoute, redirect } from '@tanstack/react-router'
import { getFirstReadableEntry, getNavData } from '@/widgets/sidebar/navData'

// The section has no page of its own — `/warehouse` opens the first sub-page
// the user's roles can read, the same one the sidebar's «Склад» links to.
export const Route = createFileRoute('/_protected/warehouse/')({
  beforeLoad: ({ context }) => {
    const warehouse = getNavData().find((item) => item.key === 'warehouse')
    // Without its own path, so the section never falls back to `/warehouse`.
    const entry =
      warehouse &&
      getFirstReadableEntry(
        { ...warehouse, path: undefined },
        context.abilityStore.abilities,
      )
    throw redirect({ to: entry?.path ?? '/forbidden', replace: true })
  },
})
